import moment from 'moment';
import 'moment/locale/pt';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import starIcon from '../../../../assets/medico-online/Star.png';
import starEmptyBorder from '../../../../assets/star-empty-border.png';
import noPhotoDoctor from '../../../../assets/medico_sem_foto.png';
import {Column, Row} from '../../../../components/layout';
import * as fonts from '../../../../util/fonts';
import {strings} from '../../../../util/strings';
import AppointmentDetails from '../../../appointment-details';
import AppointmentWarningPopup from '../../../appointment-warning-popup';
import './styles.scss';
import {Rating} from '@mui/material';
import CameraAppointmentConfirmedIcon from './assets/CameraAppointmentConfirmedIcon';
import {addToWizard} from '../../../../store/actions';
import {uriGetAppointment} from '../../../../api/endpoints';
import {get} from '../../../../api/api';
import {useLocation} from 'react-router-dom';
import {getCurrencyCode} from '../../../../util/utility';

export interface DoctorsListItemProps {
  buStyles: any;
  appointmentItem: any;
  labels: typeof strings.pt.appointments;
  borderColor?: any;
  setRefresh(value: any): void;
  nextStep?: Function;
  addToWizard(value: any): void;
}

function DoctorsListItem({
  appointmentItem,
  buStyles,
  labels,
  borderColor,
  setRefresh,
  nextStep,
  addToWizard,
}: DoctorsListItemProps) {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [appointmentClick, setAppointmentClick] = useState(false);
  const location: any = useLocation();
  const editMode = !!location.state.editingAppointmentId;

  const handleStartAppointment = async () => {
    try {
      await get(uriGetAppointment(appointmentItem.id)).then((res: any) => {
        window.open(res.data.link, '_blank')?.focus();
      });
    } catch {}
  };

  const renderDate = (date: any) => {
    const appointmentDate = date && moment(date);

    const today = new Date();
    const isAppointmentToday = moment(appointmentDate).isSame(today, 'day');

    const tomorrow = moment(today).add(1, 'days');
    const isAppointmentTomorrow = moment(appointmentDate).isSame(
      tomorrow,
      'day'
    );

    if (!isAppointmentToday && !isAppointmentTomorrow) {
      return (
        <div className="date-container-medic">
          <Row className="date-row1">
            <span style={{...fonts.SM, ...fonts.Bold}}>
              {moment(date).format('DD MMM')}
            </span>
          </Row>
        </div>
      );
    } else if (isAppointmentToday) {
      return (
        <span style={{...fonts.SM, ...fonts.Bold}}>
          {labels?.appointments_today}
        </span>
      );
    } else if (isAppointmentTomorrow) {
      return (
        <span style={{...fonts.SM, ...fonts.Bold}}>
          {labels?.appointments_tomorrow}
        </span>
      );
    }
  };

  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const renderModalAndPopups = () => {
    return (
      <>
        <AppointmentWarningPopup
          showModal={showWarningModal}
          setShowModal={setShowWarningModal}
          selectedAppointmentId={appointmentItem.id}
          status={appointmentItem.status}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
        <AppointmentDetails
          showDetailsModal={showDetailsModal}
          setShowDetailsModal={setShowDetailsModal}
          selectedAppointmentId={appointmentItem.id}
          borderColor={borderColor}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
      </>
    );
  };

  useEffect(() => {
    if (appointmentClick) {
      addToWizard({appointmentSlot: appointmentItem});
      nextStep && nextStep();
    }
  }, [appointmentClick]);

  const price = parseFloat(appointmentItem.videoPriceWithCurrency);

  return (
    <>
      <Row
        className="homepage-margin-bottom"
        onClick={() => {
          setAppointmentClick(true);
        }}>
        <Column className="appointment-doctor-column1" style={{...fonts.MM}}>
          <img
            src={appointmentItem?.photo?.normal}
            onError={loadNoPhotoDoctor}
            className="doctor-imgs"
            style={{border: `1px solid ${borderColor}`}}
          />
        </Column>
        <Column className="appointment-doctor-column2">
          <span
            style={{
              ...fonts.M,
              ...fonts.SemiBold,
              color: buStyles.primaryColor,
            }}>
            {appointmentItem.name}
          </span>
          <span style={{...fonts.SM}}>
            {appointmentItem.specialties[0]?.name}
          </span>
          <Rating
            className="ratings"
            defaultValue={
              parseFloat(appointmentItem.rating ? appointmentItem.rating : 0) /
              2
            }
            precision={0.01}
            readOnly
            icon={<img src={starIcon} width={10} />}
            emptyIcon={<img src={starEmptyBorder} width={10} />}
          />
        </Column>

        <Column className="reimbursement-history-declarationlist-column3">
          <Column className="camera-icon-column">
            <CameraAppointmentConfirmedIcon />
          </Column>
          <Column>
            {renderDate(appointmentItem.appointmentSlots[0]?.startTime)}
            <Row className="time-left-row-doctor-list">
              <div className="time-left-container-doctors-list">
                <span
                  style={{...fonts.SM, ...fonts.SemiBold}}
                  className="time-left-text-doctor">
                  {moment(
                    appointmentItem.appointmentSlots[0]?.startTime
                  ).format('HH:mm')}
                </span>
              </div>
            </Row>
            {!editMode && (
              <Row className="doctor-appointment-price">
                <span
                  style={{...fonts.SM}}
                  className="doctor-appointment-price-text">
                  {parseFloat(appointmentItem.videoPriceWithCurrency).toFixed(
                    2
                  )}{' '}
                  {getCurrencyCode(appointmentItem.currency, 'appointments')}
                </span>
              </Row>
            )}
          </Column>
        </Column>
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
      {appointmentClick && renderModalAndPopups()}
    </>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DoctorsListItem)
);
